import { ChevronDown, LogOut, BellRing, MapPin } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export function ParentUserMenu({ me, roleLabel = "Parent", onLogout, pushStatus, onEnablePush, onEditProfile }) {
  const initials = (me?.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="parent-user-menu-trigger"
          className="flex items-center gap-3 rounded-full bg-white/80 backdrop-blur border border-slate-200 pl-1.5 pr-3 py-1.5 text-left shadow-sm hover:bg-white hover:shadow transition outline-none focus-visible:ring-4 focus-visible:ring-primary/20">
          <div className="h-10 w-10 rounded-full bg-slate-900 text-white flex items-center justify-center font-display font-bold text-sm ring-2 ring-white">{initials}</div>
          <div className="hidden sm:block min-w-0 max-w-[180px]">
            <div className="font-display text-sm font-bold leading-tight text-slate-900 truncate" data-testid="parent-user-menu-name">{me?.name || "…"}</div>
            <div className="text-[11px] text-slate-500 truncate">{roleLabel}</div>
          </div>
          <ChevronDown className="h-4 w-4 text-slate-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} className="w-64 rounded-xl p-1.5 shadow-xl" data-testid="parent-user-menu">
        {pushStatus === "prompt" && (
          <>
            <DropdownMenuItem onClick={onEnablePush} data-testid="parent-enable-push" className="gap-3 rounded-lg px-3 py-2.5 text-[15px] cursor-pointer">
              <BellRing className="h-5 w-5 text-slate-500" /> Turn on notifications
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        {onEditProfile && (
          <>
            <DropdownMenuItem onClick={onEditProfile} data-testid="parent-edit-profile" className="gap-3 rounded-lg px-3 py-2.5 text-[15px] cursor-pointer">
              <MapPin className="h-5 w-5 text-slate-500" /> Billing details
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem onClick={onLogout} data-testid="parent-logout-btn" className="gap-3 rounded-lg px-3 py-2.5 text-[15px] cursor-pointer text-red-600 focus:text-red-700 focus:bg-red-50">
          <LogOut className="h-5 w-5" /> Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
